"use client";

import { Card } from "react-bootstrap";

// Helper: convert HH:MM:SS to seconds
const timeToSeconds = (timeString) => {
  if (!timeString) return 0;
  const [h = 0, m = 0, s = 0] = timeString.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};

// Convert decimal hours (e.g., 3.5) to seconds
const decimalHoursToSeconds = (hours) => Math.round(hours * 3600);

// Convert seconds back to "HHh MMm"
const secondsToHMS = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
};

const TotalProjects = ({ reports = [] }) => {
  // Sum total worked seconds
  const totalSeconds = reports.reduce((acc, r) => {
    if (!r.workedHours) return acc;

    if (typeof r.workedHours === "number") {
      // Decimal hours
      return acc + decimalHoursToSeconds(r.workedHours);
    }

    if (typeof r.workedHours === "string") {
      // HH:MM:SS format
      return acc + timeToSeconds(r.workedHours);
    }

    return acc;
  }, 0);

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <span>Total Time Worked</span>

        <h3 className="mb-0 fs-20">{secondsToHMS(totalSeconds)}</h3>

        <div className="py-3">
          <div className="wh-77 lh-97 text-center m-auto bg-primary bg-opacity-25 rounded-circle">
            <span className="material-symbols-outlined fs-32 text-primary">
              auto_stories
            </span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TotalProjects;
